import { query } from "@solidjs/router";
import { retrieveAccountDocuments } from "../roma-api/account";

export const useAccountDocuments = query(
  async (options: { groupByCategory: boolean }) =>
    retrieveAccountDocuments(options),
  "account-documents"
);
